module.exports = __webpack_public_path__ + "static/img/img5.d40e682.png";


//////////////////
// WEBPACK FOOTER
// ./static/moblieHome/img5.png
// module id = Wbtk
// module chunks = 1